import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueCookies from "vue-cookies";
import BootstrapVue from "bootstrap-vue";
import VueAnalytics from "vue-analytics";
import { Observable } from "rxjs";

import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/analytics";

import Config from "@/config/vueconfig.js";
import Validator from "@/plugins/Validator.js";
import ga from "@/plugins/GA.js";
import BBEnumCampaignType from "@/plugins/BBEnumCampaignType.js";
import RegExp from "@/plugins/RegExp.js";
import Filter from "@/plugins/Filter.js";
import Account from "@/helper/AccountHelper.js";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@splidejs/splide/dist/css/splide.min.css";

import { Slider } from 'buefy'
import './style/buefyCustom.scss'

Vue.config.productionTip = false;

Vue.use(VueCookies);
Vue.use(Config);
Vue.use(Validator);
Vue.use(ga);
Vue.use(BBEnumCampaignType);
Vue.use(RegExp);
Vue.use(Filter);
Vue.use(BootstrapVue);
Vue.use(Slider)

Vue.component('v-style', {
    render: function (createElement) {
      return createElement('style', this.$slots.default)
    }
});

new Vue({
    router,
    store,
    render: h => h(App),
    created: function() {
        Vue.initFinished = false;

        Vue.use(VueAnalytics, {
            id: Vue.bzbsConfig.bzbsGaId,
            autoTracking: {
                page: false
            }
        });

        this.initAccount();
        this.initFirebaseTracking();
    },
    methods: {
        initAccount: function() {
            Vue.subInitList = [];
            var observInit = new Observable(subscriber => {
                Vue.subInitList.push(subscriber);
            });
            Vue.observInit = observInit;

            observInit.subscribe((profile) => {
                // console.log("init profile", profile);
                this.$store.commit("setAllProfile", profile);
            });
            Account.initial();
        },
        initFirebaseTracking: function() {
            // tutorial https://razbakov.com/vue-google-firebase-analytics/
            var config = Vue.bzbsConfig.firebase;
            if (config.apiKey) {
                firebase.initializeApp(config);
                firebase.analytics();
                Vue.prototype.$analytics = firebase.analytics();
            }
        },
    }
}).$mount("#app");
//app id for consent pdpa
// 285317223476776
